import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';
import { SelectInput } from '../../../models/inputs/select-input';
import { AddClearOptionPipe } from '../../../pipes';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-select-input',
    standalone: true,
    imports: [DropdownModule, FormsModule, ReactiveFormsModule, AsyncPipe, AddClearOptionPipe, TranslateModule],
    template: `
        <p-dropdown
            inputId="{{ 'input-' + name }}"
            [class]="control.inputClass.join(' ')"
            [placeholder]="control.placeholder! | translate"
            [options]="(control.options | async) ?? [] | addClearOption : control.clearable!"
            [formControl]="control"
            optionLabel="label"
            optionValue="value"
        ></p-dropdown>
    `
})
export class SelectInputComponent extends BaseInputComponent {
    @Input() name!: string;
    @Input() override control!: SelectInput;
}
